import { useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, MainContainer } from "../../components"
import NextInputBox from "../../components/InputBox"
import { Select, RadioGroup, Radio, Button, Card, Input, CardBody, CardFooter, SelectItem, Checkbox, Chip, } from "@nextui-org/react"
import { useFetchWithBody, useGet, usePost } from "../../api/reactQueryCustomHooks"
import { ENUM_INPUT_TYPE, apiRoute, linksUrl } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCamera, faCameraAlt, faCameraRetro, faCancel, faImages, faSave, faVideoCamera } from "@fortawesome/free-solid-svg-icons"
import { resetDetail } from "../../state/itemSlice"
import { useModalToast } from "../../components/modalToast/ModalToastContext"
import InputWithSuggestions from "../../components/InputWithSuggestions"


const ProductMasterEntry = () => {

    const { detail, isNewEntry, isMultiCompany } = useSelector((state) => state.item)

    let { user } = useSelector((state) => state.auth)
    let navigate = useNavigate();
    let [isMasterItem, setIsMasterItem] = useState(false)
    let [isActive, setIsActive] = useState("0")
    let [selCat, setSelCat] = useState("")
    let [entryLabel, setEntryLable] = useState("")
    let dispatch = useDispatch();
    const [base64Image, setBase64Image] = useState("")
    const [itemImageMast, setItemImageMast] = useState([])
    const [deletedItemImage, setDeletedItemImage] = useState([])
    const [selItemImage, setSelItemImage] = useState("")
    const [selItemImageDesc, setSelItemImageDesc] = useState("")
    const [isEditMode, setIsEditMode] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const refImage = useRef()
    const { show } = useModalToast();
    const [mode, setMode] = useState("camera");


    const formField = {
        itemGroup: "itemGroup",
        itemCode: "itemCode",
        itemName: "itemName",
        mainItem: "mainItem",
        shortName: "shortName",
        itemType: "itemType",
        gstPer: "gstPer",
        gstType: "gstType",
        itemCategory: "itemCategory",
        subCategory: "subCategory",
        itemMake: "itemMake",
        unit: "unit",
        width: "width",
        hsnNo: "hsnNo",
        itemWeight: "itemWeight",
        designNo: "designNo",
        itemColor: "itemColor",
        grade: "grade",
        blockNo: "blockNo",
        rowNo: "rowNo",
        orderLevel: "orderLevel",
        // stock: "stock",
        rate: "rate",
        scrapPer: "scrapPer",
        scrapRate: "scrapRate",
        alias1: "alias1",
        alias2: "alias2",
        alias3: "alias3",
        alias4: "alias4",
        active: "active",
        masterItem: "masterItem",
        // itemType:"itemType"


    }
    useEffect(() => {
        if (isMultiCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
    }, [])
    const { data: masterData = [] } = useFetchWithBody({
        url: apiRoute.item.masterData,
        queryKey: "fetchMasterData"
    })

    const { data: gstData = [] } = useFetchWithBody({
        url: apiRoute.item.fetchGstType,
        queryKey: "fetchGstType"
    })

    const onSuccessCheckItemcode = (data) => {

        if (data && data.length > 0 && isNewEntry) {
            toast.error("Item Code exist use another ", {
                position: "top-center"
            })

        }
        else {
            funInsertUpdate({
                data: {
                    datalist: [formData],
                    user_id: user.username,
                    rec_status: !isNewEntry ? 1 : 2,
                    active: isActive,
                    m_item: isMasterItem ? 1 : 0,
                    image_list: itemImageMast,
                    deletedimage_list: deletedItemImage
                }
            })
        }
    }

    const { mutate: checkItemCode } = usePost({
        url: apiRoute.item.checkItemCode,
        queryKey: "checkItemCode",
        onSuccessTasks: onSuccessCheckItemcode
    })

    const { mutate: funGetItemImage } = usePost({
        url: apiRoute.item.getItemImage,
        queryKey: "getItemImage",
        onSuccessTasks: (data) => {
            // console.log(data, "fgh")
            // const updatedItems = [
            //     { ITEM_CODE: "", ITEM_IMAGE: "", IMAGE_DESC: "---NEW IMAGE---" },
            //     ...(data || [])
            // ];
            setItemImageMast(data)
        }
    })

    const onSuccessTasks = (data) => {
        navigate(linksUrl.catalogEntry.itemMast.productEntryMaster)
        toast.success(!isNewEntry ? "Item Updated Successfully" : "Item Inserted Successfully", {
            position: "top-center"
        })

    }

    const resetValues = () => {
        setFormData({})
        setSelCat("");
        setIsActive(false);
        setIsMasterItem(false);
    }

    const { isPending, mutate: funInsertUpdate } = usePost({
        url: apiRoute.item.addUpdate,
        queryKey: "addUpdateItem",
        onSuccessTasks,
        resetValues
    })

    const Nofield = [formField.itemWeight, formField.active, formField.orderLevel, formField.scrapPer,
    formField.scrapRate, formField.rate, formField.masterItem, formField.itemType]

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (Nofield.includes(key))
            acc[key] = 0;
        else
            acc[key] = "";
        return acc;
    }, {});

    let [formData, setFormData] = useState({
        ...emptyFormField
    })


    const inputBoxes = {
        Row1: [
            {
                name: formField.itemGroup,
                placeholder: "Item Group",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: masterData.itemGroup,
                itemkey: "ITGR_CODE",
                itemvalue: "ITGR_NAME",
                isrequired: true,
            },
            {
                name: formField.itemCode,
                placeholder: "Item Code",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },


        ],
        Row2: [
            {
                name: formField.itemName,
                placeholder: "ItemName",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {

                name: formField.itemCategory,
                placeholder: "GSM",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                isrequired: false,

            },


        ],
        Row3: [
            {
                name: formField.alias1,
                placeholder: "Composition",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {

                name: formField.width,
                placeholder: "Width",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,

            },


        ],


    }
    useEffect(() => {

    }, [detail])

    useEffect(() => {
        if (detail && detail?.length > 0 && !isNewEntry) {
            setIsActive(String(detail[0].ACTIVE))
            setIsMasterItem(detail[0].MItem)
            setSelCat(detail[0]?.CAT)
            //set Gst  and hsn no

            funGetItemImage({
                data: {
                    item_code: detail[0]?.ITEM_CODE
                }
            })
            //setSelItemImage()
            let tempdata = masterData && masterData?.itemType && masterData?.itemType.filter((ele) => ele.Item_Type_Id == detail[0]?.item_type_id);
            //console.log(masterData, detail[0]?.item_type_id, tempdata)
            setEntryLable("Update Item - " + detail[0]?.ITEM_CODE)
            setFormData({
                itemGroup: detail[0]?.ITGR_CODE ? detail[0]?.ITGR_CODE : "",
                itemCode: detail[0]?.ITEM_CODE ? detail[0]?.ITEM_CODE : "",
                itemName: detail[0]?.ITEM_DESC ? detail[0]?.ITEM_DESC : "",
                mainItem: detail[0]?.MItem_Code ? detail[0]?.MItem_Code : "",
                shortName: detail[0]?.SHORT_NAME ? detail[0]?.SHORT_NAME : "",
                itemType: detail[0]?.item_type_id ? detail[0]?.item_type_id : 0,
                itemTypeName: detail[0]?.ITEM_TYPE ? detail[0]?.ITEM_TYPE : "",
                gstPer: tempdata && tempdata.length > 0 && tempdata[0]?.STPer + tempdata[0]?.ASTPer,
                gstType: detail[0]?.GST_Type ? detail[0]?.GST_Type : "",
                itemCategory: detail[0]?.CAT ? detail[0]?.CAT : "",
                subCategory: detail[0]?.Sub_Cat ? detail[0]?.Sub_Cat : "",
                itemMake: detail[0]?.made ? detail[0]?.made : "",
                unit: detail[0]?.ITEM_UNIT ? detail[0]?.ITEM_UNIT : "",
                hsnNo: detail[0]?.HSNNO ? detail[0]?.HSNNO : "",
                itemWeight: detail[0]?.AVGKGS ? detail[0]?.AVGKGS : 0,
                designNo: detail[0]?.DESIGNNO ? detail[0]?.DESIGNNO : "",
                itemColor: detail[0]?.Color ? detail[0]?.Color : "",
                grade: detail[0]?.GRADE ? detail[0]?.GRADE : "",
                blockNo: detail[0]?.blockno ? detail[0]?.blockno : "",
                rowNo: detail[0]?.rowno ? detail[0]?.rowno : "",
                orderLevel: detail[0]?.reorder ? detail[0]?.reorder : 0,
                // stock: "stock",
                rate: detail[0]?.Rate ? detail[0]?.Rate : 0,
                scrapPer: detail[0]?.ScrapPer ? detail[0]?.ScrapPer : 0,
                scrapRate: detail[0]?.ScrapRate ? detail[0]?.ScrapRate : 0,
                alias1: detail[0]?.ALIAS1 ? detail[0]?.ALIAS1 : "",
                alias2: detail[0]?.ALIAS2 ? detail[0]?.ALIAS2 : "",
                alias3: detail[0]?.ALIAS3 ? detail[0]?.ALIAS3 : "",
                alias4: detail[0]?.ALIAS4 ? detail[0]?.ALIAS4 : "",
                active: detail[0]?.ACTIVE ? detail[0]?.ACTIVE : 0,
                masterItem: detail[0]?.MItem ? detail[0]?.MItem : 0,
                width: detail[0]?.WIDTH || 0,
            })
            //setBase64Image(detail[0]?.ITEM_IMAGE ? detail[0]?.ITEM_IMAGE : "")
            // setImageSrc(`data:image/jpeg;base64,${detail[0]?.IMAGE_SRC ? detail[0]?.IMAGE_SRC : ""}`)
            //console.log(`data:image/jpeg;base64,${detail[0].IMAGE_SRC}`)
            // const buffer = detail[0]?.ITEM_IMAGE; // { type: 'Buffer', data: [...] }


        }
        else {
            setEntryLable("Add New Item ")
        }
    }, [detail, masterData])

    const handleSubmit = (e) => {
        e.preventDefault()
        setFormData({ ...formData, active: isActive, masterItem: isMasterItem })

        checkItemCode({
            data: {
                item_code: formData.itemCode
            }
        })

    }

    const handleSelectionChange = (e) => {
        const { value, name } = e.target;
        if (name == "itemImage") {
            setSelItemImage(value)
            if (value == "---NEW IMAGE---" || value == null || value == "") {
                setSelItemImageDesc("")
                setBase64Image("")
            }
            else {

                setSelItemImageDesc(value)
                const filImage = itemImageMast.filter((ele) => ele.IMAGE_DESC == value)

                if (filImage && filImage.length > 0)
                    setBase64Image(filImage[0].ITEM_IMAGE)

            }
        }
        else {
            if (name == formField.itemType) {
                let tempdata = masterData.itemType.filter((ele) => ele.Item_Type_Id == value);
                setFormData({ ...formData, hsnNo: tempdata[0].HSNNO, gstPer: tempdata[0]?.STPer + tempdata[0]?.ASTPer })
            }
            setFormData((prev) => ({
                ...prev, [name]: value
            }))
        }
    }

    const handleInputChange = (e) => {
        const { value, name } = e.target;
        console.log(value, name)
        if (name == "imageDesc") {
            setSelItemImageDesc(value)
        }
        else {
            if (name == formField.itemCode) {
                setFormData((prev) => ({
                    ...prev, [name]: value.length > 10 ? value.substring(0, 10).toUpperCase() : value.toUpperCase()
                }))
            }
            else {
                setFormData((prev) => ({
                    ...prev, [name]: value
                }))
            }
        }
    }

    const handleClickPrev = () => {
        dispatch(resetDetail())
        navigate(linksUrl.catalogEntry.itemMast.productEntryMaster)
    }




    // const ItemImage = ({ itemImage }) => {
    //   if (!itemImage || !itemImage.data) return null;
    // console.log(itemImage,"ghj")
    //   // Convert buffer data to Base64 safely
    //   const base64Image = (() => {
    //     const chunkSize = 0x8000; // 32KB chunks to avoid call stack issues
    //     let binary = "";
    //     const bytes = itemImage.data;
    //     for (let i = 0; i < bytes.length; i += chunkSize) {
    //       const chunk = bytes.slice(i, i + chunkSize);
    //       binary += String.fromCharCode(...chunk);
    //     }
    //     return btoa(binary);
    //   })();

    //   const mimeType = "image/jpg"; // adjust if jpeg
    //   const src = `data:${mimeType};base64,${base64Image}`;

    //   return <img src={src} alt="Item" />;
    // };

    const compressImage = (base64, quality = 0.6) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = base64;

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                const MAX_WIDTH = 800;
                const scale = MAX_WIDTH / img.width;

                canvas.width = MAX_WIDTH;
                canvas.height = img.height * scale;

                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                const compressed = canvas.toDataURL("image/jpeg", quality);
                resolve(compressed); // ✅ KEEP FULL FORMAT
            };
        });
    };

    const handleFileUpload = (e) => {

        // const file = event.target.files[0];
        // if (file) {
        //     const reader = new FileReader();
        //     reader.onloadend = () => {
        //         setBase64Image(reader.result); // this includes the prefix
        //     };

       
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onloadend = async () => {
            const base64 = reader.result;

            const finalImage = await compressImage(base64);

            // setBase64Image(base64);
            setBase64Image(finalImage); // send to DB (FULL FORMAT)
        };

        reader.readAsDataURL(file);
    }
    const imgDescRef = useRef();
    const handleAddImage = () => {

        if (!base64Image) {
            toast.error("Please select image", {
                position: "top-center"
            });

            return;
        }
        if (!selItemImageDesc || selItemImageDesc.trim() === "") {
            toast.error("Image Description Required", {
                position: "top-center",
            });

            imgDescRef.current?.focus();
            return;
        }
        // 🚫 Prevent duplicate IMAGE_DESC
        const isDuplicate = itemImageMast.some(
            (item, i) =>
                item.IMAGE_DESC.toLowerCase() === selItemImageDesc.toLowerCase() &&
                i !== editIndex
        );

        if (isDuplicate) {
            toast.error("Image Description must be unique", {
                position: "top-center"
            });
            return;
        }

        if (isEditMode) {
            // ✅ UPDATE

            const updated = [...itemImageMast];

            updated[editIndex] = {
                ...updated[editIndex],
                ITEM_IMAGE: base64Image,
                IMAGE_DESC: selItemImageDesc
            };

            setItemImageMast(updated);
        } else {
            // ✅ ADD
            const newItem = {
                ITEM_IMAGE: base64Image,
                IMAGE_DESC: selItemImageDesc
            };

            setItemImageMast(prev => [...prev, newItem]);
        }

        // 🔄 Reset
        setBase64Image("");
        setSelItemImageDesc("");
        setIsEditMode(false);
        setEditIndex(null);
        if (refImage.current) {
            refImage.current.value = ''; // Clear file input
        }
    };
    const handleImageDelete = (index) => {
        const deletedItem = itemImageMast[index];

        if (!deletedItem.isNew) {
            setDeletedItemImage(prev => [...prev, deletedItem]);
        }

        setItemImageMast(prev => prev.filter((_, i) => i !== index));
    };
    console.log(deletedItemImage, "hu")
    const handleImageEdit = (item, index) => {
        setIsEditMode(true);
        setEditIndex(index);
        setBase64Image(item.ITEM_IMAGE)
        setSelItemImageDesc(item.IMAGE_DESC)
    };
    const handleCancleImage = () => {
        setIsEditMode(false);
        setEditIndex(null);
        setBase64Image("");
        setSelItemImageDesc("");
        if (refImage.current) {
            refImage.current.value = ''; // Clear file input
        }

    }

    const handleViewImage = (item) => {
        console.log(item)
        show(<div><img src={item.ITEM_IMAGE}></img></div>)
    }
    console.log(masterData)

    //console.log(base64Image.slice(0, 50));
    return (
        <div>
            <MainContainer pageName={`${isNewEntry ? "New" : "Update"} Product Entry `} info={[]} breadcrumbs={["Product", "Product Master"]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
                {/* <h4 className="mb-4 text-center font-bold leading-none tracking-tight text-gray-900 md:text-md lg:text-md dark:text-white" >
                    {entryLabel}</h4> */}
                <Card shadow="sm" radius="sm" className="mb-3 h-full">
                    <form onSubmit={handleSubmit}>
                        <CardBody className="p-2">
                            {
                                Object.keys(inputBoxes).map((key, ind) => (
                                    <div key={key + ind}>
                                        <div className="flex  flex-wrap sm:flex-nowrap md:flex-nowrap items-center gap-2 mb-5 text-base" key={ind} >
                                            {inputBoxes[key].map((item, index) => item.type == ENUM_INPUT_TYPE.select ? (
                                                item.name == formField.itemCategory ? (<>
                                                    <div className="w-full">
                                                        <h2 className=" text-xs mb-2">GSM:</h2>
                                                        <InputWithSuggestions
                                                            label="GSM"
                                                            value={formData.itemCategory}
                                                            options={masterData && masterData?.itemCategory || []}
                                                            optionKey="CAT"
                                                            onChange={(val) =>
                                                                setFormData(prev => ({ ...prev, itemCategory: val }))
                                                            }
                                                            onSelect={(item) => {
                                                                console.log("Selected:", item);
                                                            }}
                                                            onCreate={(newName) => {

                                                                // call API here if needed
                                                            }}
                                                        />
                                                    </div>

                                                    {/* <Select
                                                        isRequired={item.isrequired}
                                                        isVirtualized
                                                        name={item.name}
                                                        size="sm"
                                                        label={item.placeholder}
                                                        labelPlacement="outside"
                                                        placeholder="---select---"
                                                        selectionMode="single"
                                                        items={item.data ? item.data : []}
                                                        onSelectionChange={(e) => setSelCat(Array.from(e)[0])}
                                                        selectedKeys={String[selCat]}
                                                    // onChange={handleSelectionChange}
                                                    //selectedKeys={[String(formData[item.name])]}
                                                    >
                                                        {(list) => {
                                                            return (
                                                                <SelectItem key={list[item.itemkey]}>
                                                                    {list[item.itemvalue]}
                                                                </SelectItem>)

                                                        }}
                                                    </Select>
                                                    <Input
                                                        isRequired={item.isrequired}
                                                        name={item.name}
                                                        type={item.type}
                                                        size={item.size}
                                                        label={item.placeholder}
                                                        labelPlacement="outside"
                                                        value={selCat}
                                                        onChange={(e) => setSelCat(e.target.value)}
                                                    /> */}
                                                </>) : (
                                                    <Select
                                                        name={item.name}
                                                        size="sm"
                                                        isVirtualized
                                                        label={item.placeholder}
                                                        labelPlacement="outside"
                                                        placeholder="---select---"
                                                        selectionMode="single"
                                                        isRequired={item.isrequired}
                                                        items={item.data ? item.data : []}
                                                        onChange={handleSelectionChange}
                                                        selectedKeys={[String(formData[item.name])]}
                                                    >
                                                        {(list) => {
                                                            return (
                                                                <SelectItem key={list[item.itemkey]}>
                                                                    {list[item.itemvalue]}
                                                                </SelectItem>)

                                                        }}
                                                    </Select>)

                                            ) : (
                                                <NextInputBox
                                                    placeholder={item.placeholder}
                                                    value={formData[item.name]}
                                                    required={item.isrequired}
                                                    name={item.name}
                                                    type={item.type}
                                                    size={item.size}
                                                    label={item.placeholder}
                                                    readonly={item.name == formField.itemCode && !isNewEntry ? true : false}
                                                    labelPlacement="outside"
                                                    onChange={handleInputChange}
                                                />))}
                                        </div>
                                    </div>
                                ))
                            }
                            {/* <div className="flex felx-wrap sm:flex-nowrap md:flex-nowrap gap-5">
                                <Select
                                    name={"itemImage"}
                                    size="sm"
                                    label={"Item Image Desc"}
                                    labelPlacement="outside"
                                    placeholder="---select---"
                                    selectionMode="single"
                                    items={itemImageMast || []}
                                    onChange={handleSelectionChange}
                                    selectedKeys={[String(selItemImage)]}
                                >
                                    {(list) => { return (<SelectItem key={list.IMAGE_DESC}> {list.IMAGE_DESC} </SelectItem>) }}
                                </Select>
                                <Input type="text" name="imageDesc" label="Item Image Desc " placeholder=" "
                                    labelPlacement="outside"
                                    size="sm"
                                    value={selItemImageDesc}
                                    onChange={handleInputChange}
                                ></Input>
                            </div> */}





                            {/* 🔥 CAMERA / UPLOAD INPUT */}
                            <h2 className="text-pinfk-600 font-semibold text-sm py-2">Item Images</h2>
                            <div className="bg-gray-50 p-2">

                                <h2 style={{ fontSize: "0.7rem" }} className="text-red-400 font-semibold  py-2">Please upload a JPG or JPEG image only</h2>
                                <input
                                    type="file"
                                    accept="image/*"
                                    capture="environment"
                                    ref={refImage}
                                    style={{ display: "none" }}
                                    onChange={handleFileUpload}
                                />
                                <div className="flex gap-2">

                                    <Chip color="danger" size="md" className="text-white text-xs font-bold" onClick={() => {

                                        refImage.current.setAttribute("capture", "environment");
                                        refImage.current.click();
                                    }}>
                                        <FontAwesomeIcon icon={faCameraRetro} /> Use Camera
                                    </Chip>

                                    <Chip color="primary" size="md" className="text-white text-xs" onClick={() => {
                                        refImage.current.removeAttribute("capture");
                                        refImage.current.click();
                                    }}>
                                        <FontAwesomeIcon icon={faImages} /> Upload from Gallery
                                    </Chip>

                                </div>
                                {/* 📝 DESCRIPTION */}<div className="flex gap-5 items-center my-2">
                                    <Input
                                        type="text"
                                        name="imageDesc"
                                        label="Image Desc"
                                        placeholder="Image Desc"
                                        labelPlacement="outside"
                                        size="md"
                                        variant="bordered"
                                        className="font-semibold  bg-white  w-full mt-3"
                                        value={selItemImageDesc}
                                        onChange={(e) => setSelItemImageDesc(e.target.value)}
                                    />
                                    <div className="flex gap-2 mt-3">

                                        <Chip radius="sm"
                                            onClick={() => handleAddImage(base64Image, selItemImageDesc)}
                                            className="bg-rose-500 text-white text-xs font-bold cursor-pointer"
                                        >
                                            {isEditMode ? "Update Image" : "Add Image"}
                                        </Chip>

                                        {isEditMode && (
                                            <Chip
                                                radius="sm"
                                                onClick={handleCancleImage}
                                                className="bg-slate-700 text-white text-xs cursor-pointer"
                                            >
                                                Cancel
                                            </Chip>
                                        )}

                                    </div>
                                </div>

                                {/* 🖼️ PREVIEW */}
                                <div className="mt-3">
                                    {base64Image ? (
                                        <img
                                            src={base64Image}
                                            alt="preview"
                                            width="80"
                                            className="rounded border"
                                        />
                                    ) : (
                                        <span className="text-sm text-gray-500">
                                            No image selected
                                        </span>
                                    )}
                                </div>

                                {/* ➕ ACTION */}


                                {/* 📋 TABLE */}
                                <div className="w-full overflow-x-auto bg-white mt-4">

                                    {itemImageMast?.length > 0 && (
                                        <table className="min-w-full border text-sm border-gray-200 rounded-lg">

                                            <thead className="bg-slate-100">
                                                <tr>
                                                    <th className="px-4 py-2 text-left">Image</th>
                                                    <th className="px-4 py-2 text-left">Description</th>
                                                    <th className="px-4 py-2 text-center">Action</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {itemImageMast.map((item, index) => (
                                                    <tr key={index} className="border-t">

                                                        <td className="px-4 py-2 flex items-center gap-2">
                                                            <img
                                                                src={item.ITEM_IMAGE}
                                                                className="w-12 h-12 rounded border"
                                                                alt="item"
                                                            />

                                                            <span
                                                                className="text-red-500 text-xs cursor-pointer"
                                                                onClick={() => handleViewImage(item)}
                                                            >
                                                                View
                                                            </span>
                                                        </td>

                                                        <td className="px-4 py-2 text-sm">
                                                            {item.IMAGE_DESC}
                                                        </td>

                                                        <td className="px-4 py-2">
                                                            <div className="flex justify-center gap-2">

                                                                <Chip
                                                                    onClick={() => handleImageEdit(item, index)}
                                                                    className="bg-blue-500 text-white text-xs cursor-pointer"
                                                                >
                                                                    Edit
                                                                </Chip>

                                                                <Chip
                                                                    onClick={() => handleImageDelete(index)}
                                                                    className="bg-red-500 text-white text-xs cursor-pointer"
                                                                >
                                                                    Delete
                                                                </Chip>

                                                            </div>
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>

                                        </table>
                                    )}

                                </div>

                            </div>





                            <div className="flex  items-center  gap-2 mb-5 text-sm">

                                {/* <Checkbox isSelected={isMasterItem} onValueChange={setIsMasterItem} color="primary">Master Item</Checkbox> */}
                                <RadioGroup onValueChange={setIsActive} label="" value={isActive} orientation="horizontal" >
                                    <Radio value="0">Active</Radio>
                                    <Radio value="1">In Active (Close)</Radio>
                                </RadioGroup>




                            </div>
                            <div>
                                <CardFooter className="flex justify-center gap-4">
                                    <Button color="primary" isLoading={isPending} type="submit"
                                        variant="shadow"
                                        size="sm"
                                        startContent={<FontAwesomeIcon icon={faSave} />}>
                                        Submit
                                    </Button>
                                    <Button color="danger" size="sm" variant="shadow" onPress={handleClickPrev}
                                        startContent={<FontAwesomeIcon icon={faCancel} />}>
                                        Cancel
                                    </Button>
                                </CardFooter>
                            </div>
                        </CardBody>
                    </form>
                </Card>
            </MainContainer>
        </div>
    )
}

export default ProductMasterEntry